import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import { LAB_SANDBOX_PATH_PART_NAME } from 'bundles/labs-common/utils/LabSandboxFeatureUtils';

const LabSandboxPage = loadOnRoute(() => import('bundles/launched-lab/components/lab-sandbox/LabSandboxPage'));

export default (
  <Route>
    <Route path={LAB_SANDBOX_PATH_PART_NAME} name="labSandbox" getComponent={LabSandboxPage} />
  </Route>
);
